import { Navigate } from "react-router-dom"
import { useIntegrationsEntitlement } from "../../hooks/useIntegrationsEntitlement"
import { ROUTE_PATHS } from "../../utilities/constants"
import Loader from "../common/Loader/loader"

// Route guard for the Integration Hub: a user without the INTEGRATIONS entitlement who opens the URL
// directly is sent home, like AuthenticationGuard does for a role that may not see a page. The page
// (and its integrations request) only mounts once the entitlement is confirmed.
export const withIntegrationsEntitlement = (Component) => {
  function IntegrationsEntitledPage(props) {
    const { entitled, loading } = useIntegrationsEntitlement()
    if (loading) return <Loader />
    if (!entitled) return <Navigate to={ROUTE_PATHS.GAME_ROOT} replace />
    return <Component {...props} />
  }
  return IntegrationsEntitledPage
}
